import styles from './SelectedItemsList.module.css';
import { SelectedItem as SelectedItemType } from './types';
import CloseIcon from '@mui/icons-material/Close';

interface SelectedItemProps {
  item: SelectedItemType;
  onRemove: (value: string) => void;
}

const SelectedItem: React.FC<SelectedItemProps> = ({ item, onRemove }) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onRemove(item.value);
    }
  };

  return (
    <div
      className={`${styles.selectedItem} ${styles[item.type]}`}
      role="listitem"
      tabIndex={0}
      onKeyDown={handleKeyDown}
    >
      <span className={styles.itemLabel}>{item.label}</span>
      <button
        className={styles.removeButton}
        onClick={() => onRemove(item.value)}
        aria-label={`Remove ${item.label}`}
        data-testid={`remove-${item.value}`}
      >
        <CloseIcon fontSize="small" />
      </button>
    </div>
  );
};

export default SelectedItem;
